import React from 'react';

import { Form, Formik } from 'formik';

import {
  initialValues,
  validationSchema,
} from 'pages/freelancer/FreelancerAvailabilityPage/schema';

import Typography from 'components/typography/typography';

import { createLocale } from 'locales';

import Button from 'components/button/button';

import useUpdateFreelancerAvailableTime from 'state/remote/remote-freelancer/use-update-freelancer-available-time';

import type { FreelancerAvailableTime } from 'state/remote/types';

import FreelacerFooter from 'pages/freelancer/FreelancerAvailableJobs/components/footer/FreelancerFooter';

import FreelancerNavBar from 'pages/freelancer/FreelancerAvailableJobs/components/navigationBar/FreelancerNavBar';

import Header from './components/header';
import AvailableDayList from './components/availability-time/available-day-list';
import WeeklyScheduleRepeat from './components/weekly-schedule-repeat';
import AlertMessage from './components/alert-message';

const globalLocalize = createLocale('global');
const localize = createLocale('freelancerAvailabilityLocales');

const FreelancerAvailabilityPage: React.FC = () => {
  const updateFreelancerAvailableTimeMutation =
    useUpdateFreelancerAvailableTime();

  const onSubmit = (values: {
    availability: Array<FreelancerAvailableTime>;
    'current-week': string;
    'weekly-schedule-repeat': {
      date?: string;
      isEnabled: boolean;
    };
  }) => {
    updateFreelancerAvailableTimeMutation.mutate({
      data: {
        days: values.availability.map((day: FreelancerAvailableTime) => {
          if (!day.available) {
            return {
              ...day,
              end: null,
              start: null,
            };
          }
          return day;
        }),
        repeat: values['weekly-schedule-repeat'].isEnabled,
        repeat_end: values['weekly-schedule-repeat'].date,
      },
      date: values['current-week'],
    });
  };
  return (
    <div className="flex flex-col items-center w-full h-screen">
      <FreelancerNavBar />
      <div className="flex justify-center pb-40">
        <div className="flex flex-col gap-y-14 px-5 lg:px-0 lg:w-[1200px]">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
          >
            <Form className="flex flex-col gap-y-8 overflow-clip">
              <Header />
              <div className="flex flex-col gap-y-3 w-full">
                <div className="hidden lg:flex self-center w-3/5 mx-5">
                  <Typography
                    as="p"
                    variant="body-large-bold"
                    className="flex justify-center w-1/2"
                  >
                    {globalLocalize('startTime')}
                  </Typography>
                  <Typography
                    as="p"
                    variant="body-large-bold"
                    className="flex justify-center w-1/2"
                  >
                    {globalLocalize('endTime')}
                  </Typography>
                </div>
                <AvailableDayList />
                <Typography variant="body-large" as="p" className="text-center">
                  {localize('LeaveStartAndEndTimeBlankIfYouAreAvailableAllday')}
                </Typography>
                <WeeklyScheduleRepeat />
                <Typography variant="body-large" as="p" className="text-center">
                  {localize('UseThisDailyAvailabilityForALongerPeriodOfTime')}
                </Typography>
                <Button
                  label={globalLocalize('save')}
                  variant="primary"
                  className="w-fit"
                  type="submit"
                  disabled={updateFreelancerAvailableTimeMutation.isLoading}
                />
                {updateFreelancerAvailableTimeMutation.isSuccess &&
                  !updateFreelancerAvailableTimeMutation.isIdle && (
                    <AlertMessage
                      success={updateFreelancerAvailableTimeMutation.isSuccess}
                      message={localize('availabilitySaved')}
                    />
                  )}
              </div>
            </Form>
          </Formik>
        </div>
      </div>
      <FreelacerFooter />
    </div>
  );
};

export default FreelancerAvailabilityPage;
